<div class="h-row" [ngStyle]="{'border-color': withBorder ? 'var(--border)' : 'transparent'}">
  <div>
    <h3>{{row.description}}</h3>
    <h4 *ngIf="row?.subDescription">{{row.subDescription}}</h4>
  </div>
  <div class="hotkey">
    <span *ngFor="let key of isMac ? row.keysMac : row.keysWin; let i = index"> <span>{{key}}</span><span *ngIf="i < (isMac ? row.keysMac.length : row.keysWin.length) - 1">+</span></span>
  </div>
</div>